var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-12" }, [
    _c(
      "div",
      {
        staticClass: "annotations-side-card geometry-card",
        class: { disabled: _vm.disabled },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.onSelect.apply(null, arguments)
          },
          mouseenter: function ($event) {
            return _vm.onGeometryHighlight(_vm.fid)
          },
          mouseleave: function ($event) {
            return _vm.onGeometryHighlight(_vm.fid, false)
          },
        },
      },
      [
        _c("div", { staticClass: "annotations-side-card__wrapper" }, [
          _c(
            "div",
            { staticClass: "annotations-side-card__wrapper__container" },
            [
              _c("div", { staticClass: "side-card-content" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "side-card-content__left-container justify-content-center",
                  },
                  [
                    _c("div", { staticClass: "d-flex flex-nowrap" }, [
                      _c("div", { staticClass: "side-card-icon" }, [
                        _c("img", {
                          attrs: { src: _vm.icon, alt: "Geometry" },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "side-card-info" }, [
                        _c("div", { staticClass: "side-card-info__title" }, [
                          _c("span", [_vm._v(_vm._s(_vm.title))]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "side-card-content__right-container" },
                  [
                    _c("div", { staticClass: "side-card-tool text-center" }, [
                      _c("div", { staticClass: "btn-group my-0" }, [
                        _vm.zoomToFeature
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-sm min-w-auto btn-add",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "tooltip-city",
                                  title: "Zoom para geometria",
                                  disabled: _vm.disabled || !_vm.isValidFeature,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.onZoomTo.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-search-location",
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.removeFeature
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-sm min-w-auto btn-add",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "tooltip-city",
                                  title: "Remover",
                                  disabled: _vm.disabled,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.onRemove.apply(null, arguments)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fas fa-trash-alt" })]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }